const { CardHeader, CardBody, CardFooter, Card, Col, Row } = require("reactstrap");

function NotFound(){
  return (
    <div className="content">
    <Row>
        <Col md="12">
          <Card>
            <CardHeader className='subTitle'>Not Found</CardHeader>

            <CardBody>
              <h3>We're sorry but the page you requested is not found. Please try again.</h3>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default NotFound;